import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import { usePromotePageData } from 'src/app/pages/promote/pageContext';
import { useCurrentUser } from 'src/app/shared/hooks/session';

type Result = ModelHookResult<{
	translatedHeadline: string;
}>;

export function useHeadline(): Result {
	const {
		data: {
			featureConfigs: { useDonationLanguage },
		},
	} = usePromotePageData();
	const user = useCurrentUser();
	const { translate } = useI18n();

	const firstName = user?.firstName ?? '';
	const lastName = user?.lastName ?? '';

	const preferredName = user?.country?.countryCode !== 'JP' ? firstName : lastName;

	const translatedHeadline = useMemo(() => {
		let suffix = '';
		if (firstName) {
			suffix += '_identified';
		}
		if (useDonationLanguage) {
			suffix += '_donation';
		}
		return translate(`corgi.co.promote.headline${suffix}`, {
			preferredName,
		});
	}, [firstName, preferredName, useDonationLanguage, translate]);

	return {
		data: {
			translatedHeadline,
		},
	};
}
